<template>
	<div class="row" style="width:100%;margin-left:0px;margin-right:0px">
    <loading :active.sync="isLoading" 
        :can-cancel="false" 
        :is-full-page="true">
    </loading>
		<div class="col-sm-6">
			<el-select
				class="select-default"
				v-model="pagination.perPage"
				placeholder="Per page">
				<el-option
					class="select-default"
					v-for="item in pagination.perPageOptions"
					:key="item"
					:label="item"
					:value="item">
				</el-option>
			</el-select>
		</div>
		<div class="col-sm-6">
			<div class="pull-right">
				<fg-input class="input-sm"
									placeholder="Search"
									v-model="searchQuery"
									addon-right-icon="nc-icon nc-zoom-split">
				</fg-input>
			</div>
		</div>
		<div class="col-sm-12 mt-2">
			<el-table class="table-striped"
								:data="queriedData"
								border
								style="width: 100%"
                stripe
                :cell-class-name="tableCellClassName"
                height="570">
				<el-table-column v-for="column in tableColumns"
												:key="column.label"
												:min-width="column.minWidth"
												:prop="column.prop"
												:label="column.label"
                        :fixed="column.fixed"
        >
          <template slot-scope="scope">
            <div v-if="scope.column.property !== 'cid'">
              <div v-if="(scope.column.property == 'id_negociateur' && scope.row[scope.column.property] == '/') || scope.column.property != 'id_negociateur'">
                {{scope.row[scope.column.property]}}
              </div>
            </div>
            <div v-if="scope.column.property === 'cid'">
              <router-link class="link_table" :to="{ name: 'Client', params: { cid: scope.row[scope.column.property] }}">{{scope.row[scope.column.property]}}</router-link>
            </div>
            <div v-if="scope.column.property === 'id_negociateur' && scope.row[scope.column.property] != '/'">
              <router-link class="link_table" :to="{ name: 'Client', params: { cid: scope.row[scope.column.property] }}">{{scope.row[scope.column.property]}}</router-link>
            </div>
          </template>
				</el-table-column>
			</el-table>
		</div>
		<div class="col-sm-6 pagination-info">
			<p class="pagination-info-p">Affichage du {{from + 1}}e au {{to}}e sur les {{total}} clients</p>
		</div>
		<div class="col-sm-6">
			<p-pagination class="pull-right"
										v-model="pagination.currentPage"
										:per-page="pagination.perPage"
										:total="pagination.total">
			</p-pagination>
		</div>	
	</div>
</template>
<script>
  import Vue from 'vue'
  import {Table, TableColumn, Select, Option, Button} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  Vue.use(Button)
  export default {
    components: {
      PPagination,
      Loading
    },
    methods: {
      async getClients() {
        const self = this;
        const response = await fetch(this.$api_url+'/clients', {
          method: 'GET',
          credentials: 'include',
        });
        if(response.ok) { 
          const json = await response.json();
          //check if api return regenerated token
          if(json.code != 409) {
            self.log_api("success",'GET /clients', '', json)
            Object.keys(json).forEach(function (key) {
              self.tableData.push(json[key])
            })
            this.isLoading = false
            return json
          }
        }
        this.isLoading = false
      },
      tableCellClassName({row, column, rowIndex, columnIndex}) {
        
        if(columnIndex == 9) {
          if(row.situation_comptable !== "") {
            return "compta-bad"
          } else {
            return "compta-ok"
          }
        } else {
          let actual_timestamp = Math.floor(Date.now() / 1000)
          if(row.datelastcmd == 0) {
            return "order-never"
          } else if(actual_timestamp - row.datelastcmd > 15778800) {
            return "order-never"
          } else if(actual_timestamp - row.datelastcmd > 7889400) {
            return "order-6month"
          }
        }
        return ""
      },
    },
    computed: {
      pagedData () {
        return this.tableData.slice(this.from, this.to)
      },
      queriedData () {
        if (!this.searchQuery) {
          this.pagination.total = this.tableData.length
          return this.pagedData
        }
        let result = this.tableData
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch) {
              let rowValue = row[key].toString().toUpperCase()
              if (rowValue.includes && rowValue.includes(this.searchQuery.toUpperCase())) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination.total = result.length
        return result.slice(this.from, this.to)
      },
      to () {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from () {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      },
      total () {
        this.pagination.total = this.tableData.length
        return this.tableData.length
      },
    },
    data () {
      return {
        pagination: {
          perPage: 10,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50, 100],
          total: 0
        },
        searchQuery: '',
        propsToSearch: ['cid', 'company', 'city', 'name_contact', 'id_negociateur', 'phone', 'commercial', 'nature_client_nom'],
        tableColumns: [
          {
            prop: 'cid',
            label: '#',
            fixed: true,
            minWidth: '100'
          },
          {
            prop: 'company',
            label: 'Client',
            fixed: false,
            minWidth: '300'
          },
          {
            prop: 'name_contact',
            label: 'Contact princ.',
            fixed: false,
            minWidth: '200'
          },
          {
            prop: 'id_negociateur',
            label: '#Négo',
            fixed: false,
            minWidth: '100'
          },
          {
            prop: 'commercial',
            label: 'Commercial',
            fixed: false,
            minWidth: '150'
          },
          {
            prop: 'city',
            label: 'Localité',
            fixed: false,
            minWidth: '200'
          },
          {
            prop: 'phone',
            label: 'Téléphone',
            fixed: false,
            minWidth: '150'
          },
          {
            prop: 'nature_client_nom',
            label: 'Type',
            fixed: false,
            minWidth: '100'
          },
          {
            prop: 'last_rdv',
            label: 'Dernier rdv',
            fixed: false,
            minWidth: '200'
          },
          {
            prop: 'situation_comptable',
            label: 'Situation',
            fixed: false,
            minWidth: '200'
          }
        ],
        tableData: [],
        isLoading: true,
      }
    },
    mounted() {
      this.getClients();
    },
  }
</script>
<style lang="scss">
  .el-table .td-actions{
  button.btn {
    margin-right: 5px;
  }
  }
  .link_table {
    color: black;
    text-decoration: underline;
    font-weight: bold;
  }
  .link_table:hover {
    color: grey;
  }
  .pagination-info-p {
    font-weight: 400;
    color: #9A9A9A;
    font-size: 0.7142em;
  }
</style>